import React, { useEffect, useState } from 'react';
import axios from 'ps-components/lib/apiClient';

// Hooks
import { useToast } from 'ps-shared-ui/v4/Toast';
const toastConfig = {
  duration: 10000,
  isCloseable: true,
  type: 'error'
};

function PermittedDomains() {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(false);
  const [newDomain, setNewDomain] = useState();
  const toast = useToast();

  useEffect(() => {
    getDomains();
  }, []);

  const getDomains = async () => {
    setLoading(true);
    try {
      const res = await axios.apiPost(`/api/generic-user/superadmin/getPermittedDomains`);
      if (res.data.success) setDomains(res.data.domains);
      else toast(`failed to get permitted domains  ${res.data.message}`, toastConfig);
    } catch (err) {
      console.log(err);
      toast(`Failed to get permitted domains`, toastConfig);
    }
    setLoading(false);
  };

  const updateDomain = async ({ domain, operation = 'grant' }) => {
    setLoading(true);

    if (operation === 'grant') {
      if (!newDomain) return;
      domain = newDomain;
    }

    try {
      const res = await axios.apiPost(`/api/generic-user/superadmin/updatePermittedDomain`, { operation, domain });
      if (res.data.success) setDomains(res.data.domains);
      else toast(`failed to update permitted domains  ${res.data.message}`, toastConfig);
    } catch (err) {
      console.log(err);
      toast(`Failed to update permitted domains`, toastConfig);
    }

    setLoading(false);
  };

  return (
    <div className="permitted-domains">
      <ul>
        {domains.map(d => (
          <li key={d}>
            {d}
            <span style={{ cursor: 'pointer' }} onClick={() => updateDomain({ domain: d, operation: 'revoke' })}>
              <small> revoke</small>
            </span>
          </li>
        ))}
      </ul>
      <input type="text" onInput={e => setNewDomain(e.target.value)} /> <button onClick={updateDomain}>add</button>
    </div>
  );
}

export default PermittedDomains;
